<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">ปิดปรับปรุงระบบชั่วคราว</span>
      </div>
    </template>
    <template v-else>
      <template v-if="CheckAdmin">
        <v-card>
          <v-card-title style="color: white" class="light-blue lighten-2">
            จัดการข้อมูลสิทธิ์การใช้งาน
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-card>
                <v-row
                    class="md12 d-flex justify-center"
                >
                  <v-col
                      cols="12"
                      md="5"
                  >
                    <!--<v-responsive
                            class="text-center grey lighten-2 rounded-circle d-inline-flex align-center justify-center ma-3"
                            height="64"
                            width="64"
                    >
                        Circle
                    </v-responsive>-->  <!-- v-respronseive -->
                    <h2 class="ml-3">
                      บุคลากร
                    </h2>
                    <v-autocomplete v-model="perid" :items="StaffData" clearable item-text="fullDetail"
                                    item-value="perid"
                                    label="ค้นหาบุคลากร" @change="ChoosePerson">
                    </v-autocomplete>
                    <v-text-field label="ค้นหารายชื่อบุคลากรที่ได้รับสิทธิ์" v-model="searchPermiss"></v-text-field>
                    <v-list-item class="mt-10">
                      <v-data-table :items="DataToShow" :headers="HeaderPermiss" :search="searchPermiss">
                        <template v-slot:item.Custom="{item}">
                          <div v-html="item.Custom"></div>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-btn color="blue" @click="ShowDetailPermiss(item)" text>
                            สิทธิ์การใช้งาน
                          </v-btn>
                          <v-btn color="red" @click="DeletePermiss(item)" text>
                            ลบ
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-list-item>
                  </v-col>
                  <v-divider vertical>
                  </v-divider>
                  <v-col
                      cols="12"
                      md="5"
                  >
                    <!--<v-responsive
                            class="text-center grey lighten-2 rounded-circle d-inline-flex align-center justify-center ma-3"
                            height="64"
                            width="64"
                    >
                        Circle
                    </v-responsive>-->  <!-- v-respronseive -->
                    <v-responsive>
                      <v-list-item>
                        <v-tabs
                            v-model="tab"
                            show-arrows
                        >
                          <v-tab
                              key="1"
                          >
                            <h3 style="font-weight: bold">
                              สิทธิ์การใช้งาน
                            </h3>
                          </v-tab>
                          <v-tab
                              key="2"
                          >
                            <h3 style="font-weight: bold">
                              สิทธิ์หน่วยงาน
                            </h3>
                          </v-tab>
                          <v-tab
                              key="3"
                          >
                            <h3 style="font-weight: bold">
                              ตัวเลือกอื่น ๆ
                            </h3>
                          </v-tab>
                        </v-tabs>
                      </v-list-item>
                      <v-tabs-items v-model="tab">
                        <v-tab-item key="1">
                          <v-radio-group class="font-weight-bold" row v-model="rdoTypePermiss"
                                         @change="CheckAllPermiss">
                            <v-radio label="เลือกทั้งหมด" value="1"></v-radio>
                            <v-radio label="ไม่เลือกทั้งหมด" value="2"></v-radio>
                            <v-radio label="เฉพาะจัดประชุม (ทั้งหมด)" value="3"></v-radio>
                            <v-radio label="เฉพาะจัดประชุม (ดูอย่างเดว)" value="4"></v-radio>
                            <v-radio label="เฉพาะโครงการและเดินทาง (ทั้งหมด)" value="5"></v-radio>
                            <v-radio label="เฉพาะโครงการและเดินทาง (ดูอย่างเดว)" value="6"></v-radio>
                            <v-radio label="ข้อมูลพื้นฐานสำหรับแอดมินหน่วยงาน (ทั้งหมด)" value="7"></v-radio>
                            <v-radio label="ข้อมูลพื้นฐานสำหรับแอดมินหน่วยงาน (ดูอย่างเดียว)" value="8"></v-radio>
                            <v-radio label="ข้อมูลพื้นฐานสำหรับแอดมินหัวหน้าหน่วยงาน" value="9"></v-radio>
                          </v-radio-group>
                          <v-divider class="mt-4 mb-4 font-weight-bold"></v-divider>
                          <!--                          <v-checkbox label="เลือกทั้งหมด" color="green" @change="CheckAllPermiss"
                                                                v-model="CheckAllOption"></v-checkbox>-->
                          <v-list-item v-for="(permiss_i, idx) in PermissionMsData"
                                       v-bind:key="idx">
                            <v-checkbox :label="permiss_i.detail" color="green"
                                        v-model="permiss_i.permiss">
                              <template v-slot:label>
                                                            <span
                                                                style="font-weight: bold;font-size: 16px;color: darkgreen"
                                                                v-if="permiss_i.permiss">{{ permiss_i.detail }}</span>
                                <span style="font-weight: bold;font-size: 16px" v-else>{{ permiss_i.detail }}</span>
                              </template>
                            </v-checkbox>
                          </v-list-item>
                        </v-tab-item>
                        <v-tab-item key="2">
                          <!--                                                <v-spacer></v-spacer>-->
                          <!--                                                <v-checkbox label="เลือกทั้งหมด" color="green" @change="CheckAllPermiss"-->
                          <!--                                                            v-model="CheckAllOption"></v-checkbox>-->
                          <!--                                                <v-list-item v-for="(depart_i, idx) in DepartData" v-bind:key="idx">-->
                          <!--                                                    <v-checkbox :label="depart_i.full_Name" color="green"-->
                          <!--                                                                v-model="depart_i.dep_permiss">-->
                          <!--                                                        <template v-slot:label>-->
                          <!--                                                            <span style="font-weight: bold;font-size: 16px;color: darkgreen"-->
                          <!--                                                                  v-if="depart_i.dep_permiss">{{depart_i.full_Name}}</span>-->
                          <!--                                                            <span style="font-weight: bold;font-size: 16px" v-else>{{depart_i.full_Name}}</span>-->
                          <!--                                                        </template>-->
                          <!--                                                    </v-checkbox>-->
                          <!--                                                </v-list-item>-->
                          <v-list-item>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" label="ค้นหา" @keyup="filterItem"></v-text-field>
                          </v-list-item>
                          <v-list-item>
                            <v-spacer></v-spacer>
                            <v-btn text color="green" @click="ChooseAllDep">แสดงทั้งหมด</v-btn>
                            <v-btn text color="blue" @click="ChooseDepPermiss">แสดงเฉพาะหน่วยงานตามสิทธิ์</v-btn>
                          </v-list-item>
                          <v-data-table
                              :items="DepartDataDump"
                              :headers="DepHeader"
                          >
                            <template v-slot:header.full_Name>
                                                        <span style="font-weight: bold;font-size: 16px">
                                                           หน่วยงาน
                                                        </span>
                            </template>
                            <template v-slot:header.action>
                              <div align="center">
                                <v-checkbox v-model="CheckAllDepart" color="red"
                                            label="สิทธิ์ทั้งหมด" @change="CheckAllPermissDep"></v-checkbox>
                                <v-checkbox v-model="CheckAllSendmail" color="red"
                                            label="emailทั้งหมด" @change="CheckAllSendmailFunc"></v-checkbox>
                              </div>
                            </template>
                            <template v-slot:item.full_Name="{item}">
                                                        <span style="font-weight: bold;font-size: 16px;color: darkgreen"
                                                              v-if="item.dep_permiss">{{ item.full_Name }}</span>
                              <span style="font-weight: bold;font-size: 16px" v-else>{{ item.full_Name }}</span>
                            </template>
                            <template v-slot:item.action="{item}">
                              <v-checkbox class="font-weight-bold" v-model="item.dep_permiss" color="red"
                                          label="สิทธิ์"></v-checkbox>
                              <v-checkbox class="font-weight-bold" v-model="item.sendmail" color="red"
                                          label="email"></v-checkbox>
                            </template>
                          </v-data-table>
                          <!--<v-list-item>
                              <v-responsive class="text-center">
                                  <v-btn class="d-inline-flex ma-2" color="primary" outlined
                                         @click="SubmitDepartData">
                                      บันทึกสิทธิ์หน่วยงาน
                                  </v-btn>
                                  <v-btn class="d-inline-flex ma-2" color="red" outlined
                                         @click="cancelAllPermissDep">
                                      ยกเลิกสิทธิ์ทั้งหมด
                                  </v-btn>
                              </v-responsive>
                          </v-list-item>-->
                        </v-tab-item>
                        <v-tab-item key="3">
                          <v-list-item v-for="(opt, idx) in Option"
                                       v-bind:key="idx">
                            <v-checkbox :label="opt.text" color="green"
                                        v-model="opt.IsCheck">
                              <template v-slot:label>
                                                            <span
                                                                style="font-weight: bold;font-size: 16px;color: darkgreen"
                                                                v-if="opt.IsCheck">{{ opt.text }}</span>
                                <span style="font-weight: bold;font-size: 16px" v-else>{{ opt.text }}</span>
                              </template>
                            </v-checkbox>
                          </v-list-item>
                        </v-tab-item>
                        <v-list-item>
                          <v-responsive class="text-center">
                            <v-btn class="d-inline-flex ma-2" color="primary" outlined
                                   @click="SubmitData">
                              บันทึกสิทธิ์
                            </v-btn>
                            <!--                                                    <v-btn class="d-inline-flex ma-2" color="red" outlined-->
                            <!--                                                           @click="cancelAllPermiss">-->
                            <!--                                                        ยกเลิกสิทธิ์ทั้งหมด-->
                            <!--                                                    </v-btn>-->
                          </v-responsive>
                        </v-list-item>
                      </v-tabs-items>
                    </v-responsive>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
        <template>
          <v-dialog
              v-model="dialogDelete"
              max-width="290"
          >
            <v-card>
              <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>

              <v-card-text v-if="permissionDelete != null">
                คุณต้องการลบข้อมูลสิทธิ์การใช้งาน คุณ : {{ permissionDelete.full_Name }} ใช่หรือไม่
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="deletePermissionData"
                >
                  ตกลง
                </v-btn>
                <v-btn
                    color="red"
                    text
                    @click="dialogDelete = false"
                >
                  ยกเลิก
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </template>
      <template v-else>
        <v-card>
          <v-card-text>
            <v-responsive class="justify-center align-center text-center" height="500px">
                      <span style="font-size: 50px;font-weight: bold">
                        จัดการข้อมูลสิทธิ์การใช้งาน
                      </span>
            </v-responsive>
          </v-card-text>
        </v-card>
      </template>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";

export default {
  name: "SettingPermission",
  data() {
    return ({
      rdoTypePermiss: '2',
      maintain: false,
      searchPermiss: '',
      DataToShow: [],
      CheckAllDepart: false,
      CheckAllSendmail: false,
      search: '',
      DepartDataDupe: [],
      DepartDataDump: [],
      DepartData: [],
      CheckAllOption: false,
      tab: null,
      CheckAdmin: false,
      permissionDelete: null,
      dialogDelete: false,
      perid: '',
      StaffData: [],
      PermissionMsData: [],
      allPermission: [],
      allDepPermission: [],
      HeaderPermiss: [
        {text: 'ชื่อ - สกุล', value: 'Custom'},
        {text: '', value: 'action'},
      ],
      DepHeader: [
        {text: 'ชื่อหน่วยงาน', value: 'full_Name'},
        {text: '', value: 'action'},
      ],
      Option: [
        {text: 'รับการแจ้งเตือนเสนอโครงการผ่าน E-Mail (สำหรับผู้มีอำนาจอนุมัติ)', value: 'email', IsCheck: false}
      ]
    })
  },
  computed: {
    ...mapGetters({
      ApproveProjectData: 'Project/getApproveProject',
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      depart: 'Depart/getDepart',
      AllDepPermission: 'Permission/getAllDepPermission',
      AllPermission: 'Permission/getAllPermission',
      Permission: 'Permission/getPermission',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep: 'Permission/getPermissionDep',
      OptPermission: 'Permission/getOptPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
    })
  },
  methods: {
    ...mapActions({
      initApproveProjectData: 'Project/initApproveProjectData',
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      initPermissionOptionData: 'Permission/initPermissionOptionData',
      initPermissionData: 'Permission/initPermissionData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionData: 'Permission/getPermissionData',
      getPermissionDepData: 'Permission/getPermissionDepData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    init() {
      var CheckMatch = false
      var CheckMatchDep = false
      this.DataToShow = []
      this.allPermission = []
      this.allDepPermission = []
      this.PermissionMsData = []
      this.StaffData = []
      this.DepartData = []
      this.initDepartData().then(res => {
        if (res) {
          this.depart.map(depart_i => {
            this.DepartData.push({
              ...depart_i,
              full_Name: depart_i.dep_name + ' ' + depart_i.dep_id + ' ' + '( ' + depart_i.dep_group_name + ' )' + '( ' + depart_i.dep_group_id + ' )',
              dep_permiss: false,
              sendmail: false,
            })
          })
          this.DepartDataDump = this.DepartData
        }
      })
      this.initPermissionData().then(res => {
        if (res) {
          this.AllPermission.map(allPer => {
            if (this.DataToShow.length > 0) {
              CheckMatch = false
              this.DataToShow.map(allPer2 => {
                if (allPer.perid == allPer2.perid) {
                  CheckMatch = true
                }
              })
              if (!CheckMatch) {
                this.allPermission.push({
                  ...allPer
                })
                this.DataToShow.push({
                  ...allPer,
                  Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                      '<div style="color: brown">' + allPer.dep_name + '</div>'
                })
              }
            } else {
              this.allPermission.push({
                ...allPer
              })
              this.DataToShow.push({
                ...allPer,
                Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                    '<div style="color: brown">' + allPer.dep_name + '</div>'
              })
            }
          })

          this.initPermissionDepData().then(res => {
            if (res) {
              this.AllDepPermission.map(allPer => {
                if (this.DataToShow.length > 0) {
                  CheckMatchDep = false
                  this.DataToShow.map(allPer2 => {
                    if (allPer.perid == allPer2.perid) {
                      CheckMatchDep = true
                    }
                  })
                  if (!CheckMatchDep) {
                    this.allDepPermission.push({
                      ...allPer
                    })
                    this.DataToShow.push({
                      ...allPer,
                      Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                          '<div style="color: brown">' + allPer.dep_name + '</div>'
                    })
                  }
                } else {
                  this.allDepPermission.push({
                    ...allPer
                  })
                  this.DataToShow.push({
                    ...allPer,
                    Custom: '<span style="color: blueviolet">(' + allPer.perid + ') ' + allPer.full_Name + '</span>' +
                        '<div style="color: brown">' + allPer.dep_name + '</div>'
                  })
                }
              })
            }
          })
        }
      })
      this.initPermissionMsData().then(res => {
        if (res) {
          this.Permission_Ms.map(per_i => {
            this.PermissionMsData.push({
              ...per_i,
              permiss: false
            })
          })
        }
      })
      this.initStaffData().then(res => {
        if (res) {
          this.staffData.map(staff_i => {
            this.StaffData.push({
              ...staff_i,
              fullDetail: '( ' + staff_i.perid + ' )' + ' ' + staff_i.full_Name + ' * ' + staff_i.dep_name + ' *'
            })
          })
        }
      })
    },
    DeletePermiss(item) {
      this.permissionDelete = null
      this.permissionDelete = item
      this.dialogDelete = true
    },

    deletePermissionData() {
      this.initMeData().then(res => {
        if (res) {
          if (this.permissionDelete != null) {
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'delSettingPermission',
              param: btoa(encodeURIComponent(JSON.stringify({
                perid: this.permissionDelete.perid,
                perid_exec: this.MeData[0].perid,
                type: 'admin',
              })))
            }).then(res => {
              if (res.data.status) {
                this.$swal.fire({
                  icon: 'success',
                  title: 'ลบข้อมูลสำเร็จ'
                })
                this.dialogDelete = false
                this.init()
                this.cancelAllPermiss()
                this.cancelAllPermissDep()
                this.CheckAllSendmailFunc()
                this.CheckAllDepart = false
                this.CheckAllSendmail = false
                this.permissionDelete = null
                this.rdoTypePermiss = '2'
                this.perid = ''
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด กรุณาเลือกข้อมูลที่ต้องการลบ'
            })
          }
        }
      })
    },
    ShowDetailPermiss(item) {
      this.ChooseAllDep()
      this.perid = item.perid
      this.ChoosePerson()
    },
    filterItem() {
      this.DepartDataDump = this.DepartData.filter(item => item.full_Name.indexOf(this.search) >= 0)
    },
    ChooseAllDep() {
      this.search = ''
      if (this.DepartDataDupe.length == 0) {
        this.DepartDataDupe = this.DepartData
      }
      this.DepartDataDump = this.DepartDataDupe
    },
    ChooseDepPermiss() {
      this.search = ''
      if (this.DepartDataDupe.length == 0) {
        this.DepartDataDupe = this.DepartData
      }
      this.DepartDataDump = this.DepartDataDump.filter(dep_i => dep_i.dep_permiss)
    },
    cancelAllOptPermiss() {
      this.Option.map(item => item.IsCheck = false)
    },
    CheckAllPermissDep() {
      // this.search = ''
      // this.ChooseAllDep()
      if (this.CheckAllDepart) {
        this.DepartDataDump.map(dep_i => {
          dep_i.dep_permiss = true
        })
      } else {
        this.cancelAllPermissDep()
      }
    },
    CheckAllSendmailFunc() {
      if (this.CheckAllSendmail) {
        this.DepartDataDump.map(dep_i => {
          dep_i.sendmail = true
        })
      } else {
        this.cancelAllSendmail()
      }
    },
    cancelAllPermissDep() {
      this.DepartDataDump.map(dep_i => {
        dep_i.dep_permiss = false
      })
    },
    cancelAllSendmail() {
      this.DepartDataDump.map(dep_i => {
        dep_i.sendmail = false
      })
    },
    CheckAllPermiss() {
      this.cancelAllPermiss()
      switch (this.rdoTypePermiss) {
        case '1':
          this.PermissionMsData.map(per_i => {
            per_i.permiss = true
          })
          break
        case '2':
          this.cancelAllPermiss()
          break
        case '3':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '11000':
              case '11001':
              case '12000':
              case '12001':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        case '4':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '11000':
              case '12000':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        case '5':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '7000':
              case '7001':
              case '8000':
              case '8001':
              case '9000':
              case '9001':
              case '10000':
              case '10001':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        case '6':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '7000':
              case '8000':
              case '9000':
              case '10000':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        case '7':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '1000':
              case '1001':
              case '7000':
              case '7001':
              case '8000':
              case '8001':
              case '9000':
              case '9001':
              case '10000':
              case '10001':
              case '11000':
              case '11001':
              case '12000':
              case '12001':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        case '8':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '1000':
              case '7000':
              case '8000':
              case '9000':
              case '10000':
              case '11000':
              case '12000':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        case '9':
          this.PermissionMsData.map(per_i => {
            switch (per_i.id) {
              case '1000':
              case '1001':
              case '7000':
              case '7001':
              case '8000':
              case '8001':
              case '9000':
              case '9001':
              case '9002':
              case '10000':
              case '10001':
              case '11000':
              case '11001':
              case '12000':
              case '12001':
                per_i.permiss = true
                break
              default:
                break
            }
          })
          break
        default:
          break
      }
    },
    cancelAllPermiss() {
      this.PermissionMsData.map(per_i => {
        per_i.permiss = false
      })
    },
    ChoosePerson() {
      this.rdoTypePermiss = '2'
      this.cancelAllPermiss()
      this.getPermissionData({
        perid: this.perid
      }).then(res => {
        if (res) {
          this.PermissionMsData.map(PerMs_i => {
            this.Permission.map(Per_i => {
              if (PerMs_i.id == Per_i.permission_id) {
                PerMs_i.permiss = true
              }
            })
          })
        }
      })
      this.ChooseDepart()
      this.ChooseOption()
    },
    ChooseDepart() {
      this.cancelAllPermissDep()
      this.getPermissionDepData({
        perid: this.perid
      }).then(res => {
        if (res) {
          this.Permission_Dep.map(PerDep_i => {
            this.DepartDataDump.map(Dep_i => {
              if (PerDep_i.dep_id == Dep_i.dep_id) {
                Dep_i.dep_permiss = true
                Dep_i.sendmail = PerDep_i.sendmail == '1' ? true : false
              }
            })
          })
        }
      })
    },
    ChooseOption() {
      this.cancelAllOptPermiss()
      this.initPermissionOptionData({
        perid: this.perid
      }).then(res => {
        if (res) {
          this.OptPermission.map(optI => {
            this.Option.map(optI2 => {
              if (optI2.value == 'email') {
                if (optI.email == '1') {
                  optI2.IsCheck = true
                }
              }
            })
          })
        }
      })
    },
    SubmitData() {
      this.initMeData().then(res => {
        if (res) {
          if (this.perid != '') {
            var CheckChoice = []
            this.PermissionMsData.map(perms_i => {
              if (perms_i.permiss) {
                CheckChoice.push({
                  ...perms_i
                })
              }
            })
            var CheckChoiceDep = this.DepartDataDump.filter(perms_i => perms_i.dep_permiss)
            axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
              queryName: 'saveSettingPermission',
              param: btoa(encodeURIComponent(JSON.stringify({
                permissionSet: CheckChoice,
                permissionDep: CheckChoiceDep,
                perid: this.perid,
                perid_exec: this.MeData[0].perid,
                type: 'admin',
              })))
            }).then(async res => {
              if (res.data.status) {
                await this.SubmitOptionData(this.perid)
                this.$swal.fire({
                  icon: 'success',
                  title: 'บันทึกข้อมูลสำเร็จ'
                })
                this.init()
                this.cancelAllPermiss()
                this.CheckAllDepart = false
                this.CheckAllSendmail = false
                this.perid = ''
                this.rdoTypePermiss = '2'
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถุบันทึกข้อมูลได้โปรดลองอีกครั้ง'
                })
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดเลือกบุคลากรที่ต้องการบันทึกสิทธิ์'
            })
          }
        }
      })
    },
    SubmitDepartData() {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      if (this.perid != '') {
        this.$swal.fire({
          title: 'Please Wait !',
          html: 'กำลังบันทึกข้อมูล',// add html attribute if you want or remove
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          },
        });
        var CheckChoice = this.DepartData.filter(perms_i => perms_i.dep_permiss)
        var CheckPermiss = this.AllDepPermission.filter(perms_i => perms_i.perid == this.perid)
        if (CheckPermiss.length > 0) {
          headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart/perid/' + this.perid, '', headerAxios).then(res => {
            if (res.data.status) {
              if (CheckChoice.length > 0) {
                CheckChoice.map((depart, idx) => {
                  headerAxios = {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  }
                  const params = {
                    perid: this.perid,
                    dep_id: depart.dep_id,
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart/', params, headerAxios).then(res => {
                    if (res.data.status) {
                      if (idx == CheckChoice.length - 1) {
                        this.$swal.close();
                        this.$swal.fire({
                          icon: 'success',
                          title: 'บันทึกข้อมูลสำเร็จ'
                        })
                        this.init()
                        this.cancelAllPermissDep()
                        this.perid = ''
                      }
                    } else {
                      this.$swal.close();
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                      this.init()
                      this.cancelAllPermissDep()
                      this.perid = ''
                    }
                  })
                })
              } else {
                this.$swal.close();
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาเลือกหน่วยงาน'
                })
              }
            }
          })
        } else {
          if (CheckChoice.length > 0) {
            CheckChoice.map((depart_i, idx) => {
              headerAxios = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }
              const params = {
                perid: this.perid,
                dep_id: depart_i.dep_id,
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Depart/', params, headerAxios).then(res => {
                if (res.data.status) {
                  if (idx == CheckChoice.length - 1) {
                    this.$swal.close();
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                    this.init()
                    this.cancelAllPermissDep()
                    this.perid = ''
                  }
                } else {
                  this.$swal.close();
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ'
                  })
                  this.init()
                  this.cancelAllPermissDep()
                  this.perid = ''
                }
              })
            })
          } else {
            this.$swal.close();
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาเลือกหน่วยงาน'
            })
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดเลือกบุคลากรที่ต้องการบันทึกสิทธิ์'
        })
      }
    },
    SubmitOptionData(perid) {
      var headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      if (perid != '') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option/perid/' + perid).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option/perid/' + perid, {
              email: this.Option[0].IsCheck ? '1' : '0'
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(resUpdate => {
              if (resUpdate.data.staffData) {
                this.cancelAllOptPermiss()
              }
            })
          } else {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option', {
              email: this.Option[0].IsCheck ? '1' : '0',
              perid: perid,
              create_by: this.MeData[0].perid
            }, headerAxios).then(resPut => {
              if (resPut.data.status) {
                this.cancelAllOptPermiss()
              }
            })
          }
        }).catch(res => {
          if (res) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Permission_Option', {
              email: this.Option[0].IsCheck ? '1' : '0',
              perid: perid
            }, headerAxios).then(resPut => {
              if (resPut.data.status) {
                this.cancelAllOptPermiss()
              }
            })
          }
        })
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดเลือกบุคลากรที่ต้องการบันทึกสิทธิ์'
        })
      }
    }
  }
  ,
  mounted() {
    // this.$vuetify.theme.themes.light.primary = '#4caf50' // theme
    this.changeColor({
      color: ConstData.defaultColorApp
    })
    this.changeHeaderName({
      headerName: ConstData.defaultHeaderApp
    })
    this.changeTypeProject({
      type: null
    })
    this.initMeData().then(res => {
      if (res) {
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '20' && item.page_status == '1').length > 0) {
              this.maintain = false
              this.initApproveProjectData().then(resApprove => {
                if (resApprove) {
                  if (this.ApproveProjectData.length > 0) {
                    var CheckPermiss = []
                    CheckPermiss = this.ApproveProjectData.filter(item => item.perid == this.MeData[0].perid && item.type == '0')
                    if (CheckPermiss.length > 0) {
                      this.CheckAdmin = true
                      this.init()
                    } else {
                      this.$router.push('/')
                    }
                  }
                }
              })
            } else {
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
